<template>
  <b-card>
    <FormBuilder
      label="User"
      create
      :fields="fields"
      :loading-submit="$store.state.user.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/user'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('user/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
